// API client.
//   - dev (vite, import.meta.env.DEV): "" → /api proxied to localhost:4017 by vite
//   - everywhere else (web prod on y3lo.com, native iOS/Android): VITE_API_BASE (api.y3lo.com)
const PROD_BASE =
  (import.meta as any).env?.VITE_API_BASE ?? "https://api.y3lo.com";
const isDev = (import.meta as any).env?.DEV;
export const API_BASE = isDev ? "" : PROD_BASE;

let bearer: string | null = null;
export const setBearerToken = (t: string | null) => { bearer = t; };
export const getBearerToken = () => bearer;

export class ApiError extends Error {
  status: number;
  code: string;
  constructor(code: string, status: number) {
    super(code);
    this.status = status;
    this.code = code;
  }
}

export const api = async <T = any>(path: string, opts: RequestInit = {}): Promise<T> => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    "x-tz-offset": String(new Date().getTimezoneOffset()),
    "ngrok-skip-browser-warning": "1",
    ...((opts.headers as Record<string, string>) ?? {}),
  };
  if (bearer) headers["Authorization"] = `Bearer ${bearer}`;
  const url = API_BASE + "/api" + path;
  const res = await fetch(url, { ...opts, headers });
  if (!res.ok) {
    let body: any = {};
    try { body = await res.json(); } catch {}
    throw new ApiError(body.error ?? `HTTP_${res.status}`, res.status);
  }
  return res.json();
};
